import router from '../router';
import { ROUTE_BASE } from '@/utils/constants';
import routes from '../router/routes';

/**
 * Returns a list of routes that includes:
 * - login
 * - logout
 * - All routes that are not login enforced from the given list
 *
 * @param routeList
 */
export function getNoAuthRequiredRoutes(routeList = []) {
  return ['login', 'logout'].concat(
    routeList
      .filter((route) => {
        route = route || {};
        const meta = route.meta || {};
        return meta.skipAuthentication;
      })
      .map((route) => route.path.split('/')[1])
  );
}

/**
 * Handle redirections when entering the app from auth0.
 * This will check the auth0 appState and redirect to a pathname on the
 * `fromPath` field if is not the current route or the login/logout route.
 *
 * If the `fromPath` is not defined, this will redirect to the windows pathname
 * to clear any auth0 query parameters in the URL.
 *
 * @param currentPathname
 * @param fromPathname
 * @param routeList
 */
export function shouldGoToFromPath(currentPathname, fromPathname, routeList) {
  if (!fromPathname || currentPathname === fromPathname) {
    return false;
  }

  const nonAuthRequiredRoutes = getNoAuthRequiredRoutes(routeList);
  for (let i = 0; i < nonAuthRequiredRoutes.length; i++) {
    if (fromPathname.includes(nonAuthRequiredRoutes[i])) {
      return false;
    }
  }

  return true;
}

/**
 * Redirect to the current pathname or where the user has come from.
 *
 * @param appState
 */
export default function onRedirectCallback(appState = {}) {
  const currentPathname = window.location.pathname.replace(ROUTE_BASE, '');
  const fromPathname = appState.fromPath;

  const goToFromPath = shouldGoToFromPath(
    currentPathname,
    fromPathname,
    routes
  );

  router.push(goToFromPath ? fromPathname : currentPathname);
}
